import { getOrdersSettings as publicGetOrdersSettings, updateOrdersSettings as publicUpdateOrdersSettings, } from './ecom-v1-orders-settings-orders-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import { onOrdersSettingsUpdated as publicOnOrdersSettingsUpdated } from './ecom-v1-orders-settings-orders-settings.public.js';
export const getOrdersSettings = /*#__PURE__*/ createRESTModule(publicGetOrdersSettings);
export const updateOrdersSettings = /*#__PURE__*/ createRESTModule(publicUpdateOrdersSettings);
/**
 * Triggered when orders settings are updated.
 */
export const onOrdersSettingsUpdated = createEventModule(publicOnOrdersSettingsUpdated);
export { InventoryUpdateTrigger, WebhookIdentityType, } from './ecom-v1-orders-settings-orders-settings.universal.js';
//# sourceMappingURL=ecom-v1-orders-settings-orders-settings.context.js.map